import { USER_AREA_BASE_PATH } from '@pm2/api';
import { useNotifier } from '@provider/notifier';
import { breakpoints } from '@ui/css';
import { Link, Button } from '@ui/kit';
import { TeamsIcon, AddTeamIcon } from '@ui/kit/icons';
import { HideFor, ShowFor } from '@utils/react';
import { Routes } from '../../../const.routes.js';
import { makeTeamModalConfig } from '../../settings/molecule.my-teams/modal.create-team.js';
import { link, wrapper, heading, body, button } from './atom.empty-state.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function TeacherEmptyState() {
  const notifier = useNotifier();
  const handleCreateTeam = () => {
    notifier.modal(makeTeamModalConfig({}));
  };
  const teamsLinkComp = /*#__PURE__*/jsxs(Link, {
    href: `${USER_AREA_BASE_PATH}/${Routes.TEAMS}`,
    className: link,
    theme: "inline",
    children: [/*#__PURE__*/jsx(TeamsIcon, {
      height: "20"
    }), "Mine Hold"]
  });
  return /*#__PURE__*/jsxs("div", {
    className: wrapper,
    children: [/*#__PURE__*/jsxs("h1", {
      className: heading,
      children: [/*#__PURE__*/jsx(HideFor, {
        breakpoint: breakpoints.mobile,
        children: "Du har ingen besvarelser"
      }), /*#__PURE__*/jsx(ShowFor, {
        breakpoint: breakpoints.mobile,
        children: "Opret dine hold p\xE5 computer"
      })]
    }), /*#__PURE__*/jsxs("p", {
      className: body,
      children: [/*#__PURE__*/jsxs(HideFor, {
        breakpoint: breakpoints.mobile,
        children: ["Opret de hold du \xF8nsker at modtage besvarelser fra. ", /*#__PURE__*/jsx("br", {}), "Du kan altid oprette flere hold under ", teamsLinkComp]
      }), /*#__PURE__*/jsxs(ShowFor, {
        breakpoint: breakpoints.mobile,
        children: ["Du har endnu ingen besvarelser fra elever. For at kunne modtage besvarelser fra dine elever skal du oprette de hold, du \xF8nsker at modtage besvarelser fra.", /*#__PURE__*/jsx("br", {}), /*#__PURE__*/jsx("br", {}), "Dette kan du g\xF8re fra din computer under ", teamsLinkComp]
      })]
    }), /*#__PURE__*/jsx(HideFor, {
      breakpoint: breakpoints.mobile,
      children: /*#__PURE__*/jsx(Button, {
        className: button,
        theme: "primary",
        icon: /*#__PURE__*/jsx(AddTeamIcon, {}),
        onClick: handleCreateTeam,
        children: "Opret hold"
      })
    })]
  });
}

export { TeacherEmptyState };
//# sourceMappingURL=atom.empty-state.js.map
